import { useState } from "react";
import { useOutletContext } from "react-router-dom";
import { useData } from "../../context/DataContext";
import { C } from "../../styles/theme";
import Badge from "../../components/common/Badge";
import Fld from "../../components/common/Fld";
import Dlg from "../../components/common/Dlg";
import { ABt, filt } from "../AdminUI";

export default function JobsTab() {
  const { db, saveDB, delDB } = useData();
  const { toast, srch } = useOutletContext();
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState({});
  const fs = k => v => setForm(f => ({ ...f, [k]: v }));
  const close = () => { setModal(false); setForm({}); };
  const save = r => { saveDB("jobs", r); toast(r.id ? "Updated" : "Added"); close(); };
  const del = id => { delDB("jobs", id); toast("Deleted"); };

  return (
    <>
      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 12 }}>
        <ABt variant="orange" onClick={() => { setForm({ title: "", dept: "Software Development", location: "Mumbai", type: "Full-time", exp: "", status: "open", applicants: 0, posted: new Date().toISOString().slice(0, 10) }); setModal(true); }}>+ Post Job</ABt>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        {filt(db.jobs, ["title", "dept", "status"], srch).map(j => (
          <div key={j.id} style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 11, padding: "15px 18px", display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 10, alignItems: "center", boxShadow: "0 2px 5px rgba(0,0,0,.04)" }}>
            <div style={{ flex: 1, minWidth: 200 }}>
              <div style={{ fontSize: 14, fontWeight: 700, color: C.blue, marginBottom: 6 }}>{j.title}</div>
              <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 5 }}>{[j.dept, j.location, j.type, j.exp].map(t => <span key={t} style={{ background: "#f1f5f9", border: "1px solid #e2e8f0", padding: "2px 8px", borderRadius: 20, fontSize: 11, fontWeight: 600, color: "#475569" }}>{t}</span>)}</div>
              <div style={{ fontSize: 11, color: "#94a3b8" }}>{j.posted} · <strong style={{ color: C.blue }}>{j.applicants} applicants</strong></div>
            </div>
            <div style={{ display: "flex", gap: 6, alignItems: "center", flexShrink: 0 }}>
              <Badge v={j.status} />
              <ABt variant={j.status === "open" ? "red" : "green"} onClick={() => save({ ...j, status: j.status === "open" ? "closed" : "open" })}>{j.status === "open" ? "Close" : "Reopen"}</ABt>
              <ABt onClick={() => { setForm({ ...j }); setModal(true); }}>Edit</ABt>
              <ABt variant="red" onClick={() => del(j.id)}>Del</ABt>
            </div>
          </div>
        ))}
      </div>

      {modal && <Dlg title={form.id ? "Edit Job" : "Post Job"} onClose={close}>
        <Fld label="Job Title" value={form.title || ""} onChange={fs("title")} />
        <Fld label="Department" value={form.dept || "Software Development"} onChange={fs("dept")} opts={["Staffing", "Software Development", "Cyclojet Lab", "Valuation", "Operations"]} />
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 11 }}><Fld label="Location" value={form.location || ""} onChange={fs("location")} /><Fld label="Job Type" value={form.type || "Full-time"} onChange={fs("type")} opts={["Full-time", "Part-time", "Contract", "Internship"]} /></div>
        <Fld label="Experience" value={form.exp || ""} onChange={fs("exp")} />
        <Fld label="Status" value={form.status || "open"} onChange={fs("status")} opts={["open", "closed"]} />
        <ABt variant="orange" onClick={() => save(form)}>{form.id ? "Update" : "Post"} Job</ABt>
      </Dlg>}
    </>
  );
}
